module.exports = __webpack_public_path__ + "static/media/apple.28292c4a.png";